<template>
  <grid ref="myGrid" :gridConfigUrl="gridConfigUrl">
    <template slot="lastHeaderColumns" slot-scope="props">
      <grid-table-th
        v-if="props.magicalMenuCodes.includes('usageRecord')"
        width="80px"
      >使用记录
      </grid-table-th>
    </template>
    <template slot="lastBodyColumns" slot-scope="props">
      <grid-table-td
        v-if="props.magicalMenuCodes.includes('usageRecord')"
        @click.native="handle(props.row)"
        width="80px"
      >使用记录
      </grid-table-td>
    </template>
  </grid>
</template>
<script>
import Grid from '../../../components/grid/grid.vue'
import GridTableTh from '../../../components/grid-menu/grid-table-th'
import GridTableTd from '../../../components/grid-menu/grid-table-td'
import GridTopMenu from '../../../components/grid-menu/grid-top-menu'
import util from '../../../libs/util'

export default {
  components: {
    GridTopMenu,
    GridTableTd,
    GridTableTh,
    Grid
  },
  name: 'api-service-show',
  data() {
    return {
      gridConfigUrl: ''
    }
  },
  created() {
    this.gridConfigUrl = this.$route.meta.url
  },
  methods: {
    handle(data) {
      let routerName = data.code + '-usage-record'
      if (this.$router.resolve({name: routerName}).resolved.matched.length > 0) {
        util.changeRouter(this, {
          name: routerName
        })
      } else {
        this.$notify.error({title: data.name, message: '该服务的使用记录暂未提供'})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/custom/components/grid/api-service-show.vue